<template>
  <div class="view-req-detail" dir="rtl">
    <div class="">
      <div
        ref="form"
      >
        <div>
          <ul class="relative">
            <!--            *****************************-->
            <li>
              <label>دسته بندی</label>
              <span>
                  {{request_info.type_name}} {{request_info.group_name}} {{request_info.subgroup_name}}
              </span>
            </li>
            <hr>
            <li>
              <label>مدل دستگاه</label>
              <span>
                {{request_info.device_model}}
              </span>
            </li>
            <hr>

            <!--            *****************************-->
            <li>
              <label>نام مشتری</label>

              <span>
                {{request_info.customer}}
              </span>
            </li>
            <hr>

            <li>
              <label>شماره موبایل مشتری</label>
              <span>
                {{request_info.customer_mobile}}
              </span>
            </li>
            <hr>

            <li>
              <label>توضیحات درخواست</label>

            </li>
            <li>
              <span>
                {{request_info.summary}}
              </span>
            </li>
            <hr>

            <li>
              <label>زمان باقیمانده تا پذیرش {{remaining_time}} ثانیه</label>
              <span>
                <v-progress-linear
                  v-model="remaining_time"
                  :buffer-value="120"
                ></v-progress-linear>
              </span>
            </li>

          </ul>
        </div>
        <div>
          <div :style="{ height: '250px'}" id='map2'></div>
        </div>
        <div>
          <v-row>
            <v-col>
              <v-btn class="width-100-p"  @click="accept_online_request_refer_dialog=true"  color="primary" >
                پذیرش درخواست
              </v-btn>
            </v-col>
            <v-col>
              <v-btn class="width-100-p" @click="cancel_online_request_refer_dialog=true" color="primary" >
                رد درخواست
              </v-btn>
            </v-col>
          </v-row>

        </div>
      </div>
      <v-dialog
        v-model="cancel_online_request_refer_dialog"
        max-width="290"
        fullscreen
        hide-overlay
      >

        <v-card class="category-modal">
          <v-card-title class="headline">
            رد درخواست
          </v-card-title>
          <v-card-text>
            <v-row class="relative">
              <v-col cols="12">
                <v-select
                  :items="status_list_items"
                  label="دلیل لغو"
                  single-line
                  item-text="label"
                  item-value="value"
                  v-model="selected_status_for_change"
                >
                </v-select>
              </v-col>
            </v-row>
            <v-row class="relative">
              <v-col cols="12">
                <v-textarea
                  rows="2"
                  v-model="change_status_summary" :placeholder="$t('insertChangeStatusSummary')"/>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="">
            <v-spacer></v-spacer>

            <v-btn
              class="cancle-btn"
              text
              @click="cancel_online_request_refer_dialog = false"
            >
              {{$t('cancel')}}
            </v-btn>
            <v-btn
              v-if="selected_status_for_change != 0"
              class="accept-btn"
              text
              @click="cancel_online_request()"
            >
              {{$t('ok')}}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="accept_online_request_refer_dialog"
        max-width="290"
        fullscreen
        hide-overlay
      >

        <v-card class="category-modal">
          <v-card-title class="headline">
            قبول درخواست
          </v-card-title>
          <v-card-text>

            <v-row class="relative">
              <v-col cols="12">
                <v-textarea
                  rows="2"
                  v-model="change_status_summary" :placeholder="$t('insertChangeStatusSummary')"/>
              </v-col>
            </v-row>

          </v-card-text>
          <v-card-actions class="">
            <v-spacer></v-spacer>

            <v-btn
              class="cancle-btn"
              text
              @click="accept_online_request_refer_dialog = false"
            >
              {{$t('cancel')}}
            </v-btn>
            <v-btn
              v-if="selected_status_for_change != 0"
              class="accept-btn"
              text
              @click="accept_online_request()"
            >
              {{$t('ok')}}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>
<script>
  import {bus} from '../../main.js'

  export default {
    props: [
      'passing_data'
    ],
    data() {
      return {
        cancel_online_request_refer_dialog:false,
        accept_online_request_refer_dialog:false,
        remaining_time:120,
        remaining_time_timer:null,
        change_status_summary:'',
        change_status_dialog:false,
        status_list_items: [],
        selected_status_for_change: 0,
        errors: [],
        request_info: {},
        action_button_text: '',
        request_statuses: [],
        next_action_status: 0,
        branch_id: 0,

        technician_name: 'hamid mokhtari',
        device_password: 'hamid mokhtari',
        user_location_lat:null,
        user_location_lng:null,
        map: null,
        polygon_area: [
          [-67.13734351262877, 45.137451890638886],
          [-66.96466, 44.8097],
          [-68.03252, 44.3252],
          [-69.06, 43.98],
          [-70.11617, 43.68405],

        ],
        first_map:true,
      }
    },
    watch: {
      selected_province: function () {
        this.get_cities()
      }
    },
    mounted() {
      this.request_info = JSON.parse(localStorage.getItem("online_request_refer_data"))
      this.set_remaining_time()
      this.user_location_lat = this.request_info.lat;
      this.user_location_lng = this.request_info.lng;
      setTimeout(() => {

        this.createMap()
      }, 1000);
      // var passing_data = JSON.parse(localStorage.getItem('request_data'));
      // this.enable_send_from_country = passing_data.on_site_service;
      // this.get_phone_prefix()
      // this.get_device_status()
      // this.get_provinces()
      this.get_stats_list()
    },
    methods: {
      set_remaining_time(){
        this.remaining_time_timer = setTimeout(() => {
          this.remaining_time--;
          if(this.remaining_time<=0){
            this.selected_status_for_change = this.status_list_items[this.status_list_items.length-1].value;
            this.change_status_summary= "اتمام زمان"
            this.cancel_online_request()
          }else {
            this.set_remaining_time()
          }
        }, 1000)
      },
      get_stats_list() {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        // const send_data = {
        //   ExpertId: user_id,
        //   RequestId: this.$route.params.rec_id,
        // }
        var formData = new FormData();
        formData.append('ExpertId',user_id);
        formData.append('RequestId',this.$route.params.rec_id);
        // this.axios.post('/Register' , send_data,{
        this.axios.post('https://cp.zoodkomak.com/api/refer_request_status', formData, {})
          .then(response => {
              response.data.data.forEach(function (number) {
                var obj = {value: number.id, label: number.title}
                self.status_list_items.push(obj)
              })
              self.selected_status_for_change = self.status_list_items[0].value;

          }).catch(e => {
          this.errors.push(e)
        })
      },
      cancel_online_request() {
        var self = this;
        const send_data = {
          mobile: localStorage.getItem("phone").replace("+98","0"),
          request_id: this.request_info.id,
          status_id: this.selected_status_for_change,
          summary: this.change_status_summary,
        }
        this.cancel_online_request_refer_dialog = false

        // this.axios.post('/Register' , send_data,{
        this.axios.post('https://cp.zoodkomak.com/api/cancel_online_request_refer', send_data, {})
          .then(response => {
            bus.$emit('show_toast', [2000, response.data.msg])
            clearTimeout(this.remaining_time_timer)
            self.$router.push({ path: "/home-tab", params: {} });
          }).catch(e => {
          this.errors.push(e)
        })
      },
      accept_online_request() {
        var self = this;
        const send_data = {
          mobile: localStorage.getItem("phone").replace("+98","0"),
          request_id: this.request_info.id,
          status_id: this.status_list_items[this.status_list_items.length-1].value,
          summary: this.change_status_summary,
        }
        this.accept_online_request_refer_dialog = false
        // this.axios.post('/Register' , send_data,{
        this.axios.post('https://cp.zoodkomak.com/api/accept_online_request_refer', send_data, {})
          .then(response => {
            bus.$emit('show_toast', [2000, response.data.msg])
            clearTimeout(this.remaining_time_timer)

            self.$router.push({ path: "/home-tab", params: {} });
          }).catch(e => {
          this.errors.push(e)
        })
      },
      createMap() {
        var self = this;
        // init the map
        mapboxgl.accessToken = 'pk.eyJ1Ijoib21kZXNobyIsImEiOiJjanoyaW1zNG4wMHI1M2JteTQyZXhqaTI3In0.M0GJxZnal_ysW7mxXWEZLg';
        try{
          if(this.first_map) {
            mapboxgl.setRTLTextPlugin(
              'https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-rtl-text/v0.2.3/mapbox-gl-rtl-text.js',
              null,
              true // Lazy load the plugin
            );
            this.first_map = false;
          }
        }catch (e) {

        }

        var center_loc = [this.user_location_lng, this.user_location_lat];

        self.map = new mapboxgl.Map({
          container: 'map2',
          style: 'mapbox://styles/mapbox/streets-v11', // stylesheet location
          center: center_loc,
          zoom: 14 // starting zoom
        });
        var latlng = new mapboxgl.LngLat(this.user_location_lng,this.user_location_lat);
        self.map.resize();
        self.marker = new mapboxgl.Marker({
          draggable: true
        })

          .setLngLat(latlng)
          .addTo(self.map);

        // self.polygon_draw = new MapboxDraw({
        //   displayControlsDefault: false,
        //   controls: {
        //     polygon: true,
        //     trash: true
        //   }
        // });

        // self.map.addControl(self.polygon_draw);
        // self.map.on('draw.create', self.updatePolygonArea);
        // self.map.on('draw.delete', self.updatePolygonArea);
        // self.map.on('draw.update', self.updatePolygonArea);

        // self.map.addControl(new mapboxgl.Navigation())
        // self.map.on('click', function (e) {
        //   if (self.marker != null) {
        //     self.marker.remove();
        //   }
        //   // if (self.user_location_lat == 0) {
        //
        //   self.marker = new mapboxgl.Marker({
        //     draggable: true
        //   })
        //
        //     .setLngLat(e.lngLat)
        //     .addTo(self.map);
        //   self.user_location_lat = e.lngLat.lat;
        //   self.user_location_lng = e.lngLat.lng;
        //
        //   // }
        //
        //   function onDragEnd() {
        //     // var lngLat = marker.getLngLat();
        //     self.user_location_lat = self.marker.getLngLat().lat;
        //     self.user_location_lng = self.marker.getLngLat().lng;
        //
        //   }
        //
        //   function onDragStart() {
        //     // var lngLat = marker.getLngLat();
        //     console.log("drag started");
        //     self.user_location_lat = self.marker.getLngLat().lat;
        //     self.user_location_lng = self.marker.getLngLat().lng;
        //
        //   }
        //
        //   self.marker.on('dragend', onDragEnd);
        //   self.marker.on('dragstart', onDragStart);
        //   console.log('A click event has occurred at ' + e.lngLat);
        //   // }
        //
        // });

        self.map.on('load', function () {
          // self.show_polygon();
          self.map.resize();
          console.log("map loaded")
        });
      },
      updatePolygonArea() {
        var data = this.polygon_draw.getAll();
        // console.log(data);
        if (data.features.length > 0) {
          this.polygon_area = data.features[0].geometry.coordinates;
          this.show_polygon();

        } else {
          this.polygon_area = [];
          this.show_polygon();

        }
      },
      show_polygon() {

        this.map.addSource('maine', {
          'type': 'geojson',
          'data': {
            'type': 'Feature',
            'geometry': {
              'type': 'Polygon',
              'coordinates': this.polygon_area

            }
          }
        });
        this.map.addLayer({
          'id': 'maine',
          'type': 'fill',
          'source': 'maine',
          'layout': {},
          'paint': {
            'fill-color': '#088',
            'fill-opacity': 0.8
          }
        });


      },
    },

  }
</script>
